import React, { useState, useEffect } from "react";
import { Calendar } from "lucide-react";

/**
 * Renders an event image with a graceful EUNOIA-style placeholder fallback.
 * - Empty/missing src → placeholder
 * - Image fails to load (404, blocked, etc.) → placeholder (NO broken icon)
 * - Otherwise → cover image with optional hover zoom
 *
 * Props:
 *   src, alt, className, hoverZoom (bool)
 */
export default function EventImage({ src, alt, className = "", hoverZoom = false }) {
  const [failed, setFailed] = useState(false);

  useEffect(() => { setFailed(false); }, [src]);

  const showImage = src && !failed;

  if (!showImage) {
    return (
      <div
        className={`w-full h-full flex items-center justify-center ${className}`}
        style={{
          background:
            "linear-gradient(135deg, var(--eunoia-breath) 0%, var(--eunoia-whisper) 50%, var(--eunoia-light) 100%)",
        }}
        data-testid="event-image-placeholder"
      >
        <Calendar className="h-12 w-12 opacity-40" style={{ color: "var(--eunoia-gentle)" }} />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt || ""}
      onError={() => setFailed(true)}
      loading="lazy"
      className={`w-full h-full object-cover ${hoverZoom ? "group-hover:scale-105 transition-transform duration-300" : ""} ${className}`}
    />
  );
}
